import { DeleteOutlined, EditOutlined, PrinterOutlined } from "@ant-design/icons";
import { Button, Image, message, Space, Tag } from "antd";
import { create } from "zustand";
import { MAIN_URL } from "../../../../Constants";
import axios from "axios";
import emptyimage from '../../../../assets/images/emptyimage.jpg'
import PrintNakl from "./PrintNakl";
import Barcode from "react-barcode";

export const useVariations = create((set, get) => ({
    variations: [],
    open: false,
    editOpen: false,
    setEditOpen: (s) => set({ editOpen: s }),
    editV: {},
    setEditV: (v) => set({ editV: v }),
    setOpen: (s) => set({ open: s }),
    vr: {},
    setV: (v) => set({ vr: v }),
    getVariations: (id) => {
        axios.get('/variations/' + id).then(res => {
            set({ variations: res.data })
        })
    },
    addVariation: (data) => {
        axios.post('/create-variation', data).then(res => {
            message.success('Variation added successfully')
            get().getVariations(get().vr.id)
            get().setOpen(false)
        }).catch(err => {
            message.error('Variation added failed')
        })
    },
    editVariation: (data) => {
        axios.put('/update-variation/' + data.id, data).then(res => {
            message.success('Variation edited successfully')
            get().getVariations(get().vr.id)
            get().setOpen(false)
            get().setEditOpen(false)
        }).catch(err => {
            message.error('Variation edited failed')
        })
    },
    vcolumns: [
        {
            key: 'img',
            title: 'Img',
            dataIndex: 'img',
            render: (text, record) => <Image alt="example" src={record.img ? MAIN_URL + '/' + record.img : emptyimage} width={75} height={75} style={{ objectFit: 'cover' }} />
        },

        {
            key: 'sku',
            title: 'Kodi',
            dataIndex: 'sku',
            render: (text, record) => <><span><Barcode format="CODE128" width={1} height={20}  value={record.sku} /></span> <br />  <Tag color={record.count >= record.min_count ? "blue" : "red"} style={{ marginTop: '10px', fontSize: '18px' }}><b>Soni:</b> {record.count}</Tag></>
        },
        {
            key: 'price_uzs',
            title: 'Narxi',
            dataIndex: 'price_uzs',
            render: (text, record) => <><span><b>Narxi:</b> {record.price_uzs} so'm</span> <br /> <span><b>Narxi Dollarda:</b> {record.price_usd} $</span></>
        },
        {
            key: 'dis_uzs',
            title: 'Chegirma narxi',
            dataIndex: 'dis_uzs',
            render: (text, record) => <><span><b>Narxi:</b> {record.dis_uzs} so'm</span> <br /> <span><b>Narxi Dollarda:</b> {record.dis_usd} $</span></>
        },
        {
            key: 'country',
            title: 'Qo’shimcha ma’lumotlar',
            dataIndex: 'country',
            render: (text, record) => <>
            <span><b>Davlat:</b> {record.country}</span> <br /> 
            <span><b>Ishlab chiqaruvchi:</b> {record.manufacturer}</span> <br /> 
            <span style={{ marginTop: '10px', color: record.color_code }}><b>Rangi:</b> {record.color}</span><br /> 
            <span><b>Qo'shimcha parametr:</b> {record.parametr}</span> 
            </>
        },

        {
            key: 'barcode',
            title: 'Galereya',
            dataIndex: 'barcode',
            render: (text, record) => {
                let images = JSON.parse(record.galery)
                return images?.map(img=><Image key={img} src={MAIN_URL + '/' + img} width={75} height={75} style={{ objectFit: 'cover' }} />)
            }
        },
        {
            key: 'actions',
            title: 'Uskunalar',
            render: (text, record) => (
                <Space>
                   <PrintNakl data={record} pr={get().vr}/>
                   <Button type="primary" icon={<EditOutlined />} onClick={() => {
                        get().setEditOpen(true)
                        get().setEditV(record)
                    }} />
                    <Button type="primary" icon={<DeleteOutlined />} danger onClick={() => {
                        axios.delete(`delete-variation/${record.id}`).then(res => {
                            get().getVariations(get().vr.id)
                        })
                    }} />
                </Space>
            )
        }
    ],
}))